/*
  vendor.js already bundles Flickity 2.3.0 - the exact version this theme's
  custom carousels use - along with the AsNavFor, Fade and ImagesLoaded plugins.
  It exposes them on `themeVendor`, not as globals, so custom sections calling
  `new Flickity(...)` used to need a second, byte-identical copy of the library
  (assets/flickity.pkgd.min.js, ~57 KB, plus a cross-origin unpkg.com copy on
  some templates). Aliasing the bundled build onto window removes those copies
  entirely; Flickity's stylesheet is likewise already part of theme.css.

  Loaded <script defer> immediately after vendor.js in layout/theme.liquid.
  Deferred scripts execute in DOM order and all of them run before
  DOMContentLoaded, so `window.Flickity` is defined before any section's
  DOMContentLoaded handler constructs a carousel - the same ordering guarantee
  the separate <script defer> tags relied on, one step earlier in the chain.
*/
(function () {
  'use strict';

  var vendor = window.themeVendor;
  if (!vendor) return;

  ['Flickity', 'FlickityAsNavFor', 'FlickityFade', 'FlickityImagesLoaded'].forEach(function (name) {
    if (vendor[name] && typeof window[name] === 'undefined') {
      window[name] = vendor[name];
    }
  });
})();
